/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

 import React from "react"
 import PropTypes from "prop-types"
 import { Helmet } from "react-helmet"
 import { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr, toTitleCase } from "./utils"
 import { useLocation } from "@reach/router"

 import _ from "lodash"
 export { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "./utils";

 const SeoResults = ({ description, lang, meta, title, searchParams, location, pcategorytype }) => {
 
   const {areas, bedrooms, pType, type, price, commType, mustInclude } = searchParams;
   const actionStr = ACTION_TYPES[pType];
   const actionStrDESC = ACTION_DESC_TYPES[pType];

   const priceStr = getPriceStr(price)
   const bedRooms = searchParams.bedrooms
 
   const capitalize = (s) => {
     if (typeof s !== 'string') return ''
     return s.charAt(0).toUpperCase() + s.slice(1)
   }
 
   let propertyType = ""
 
  if(type == "") {
    propertyType = "Properties"
    if(pcategorytype === "new_developments") {
      propertyType = "New Homes";
    }
  } else {
    propertyType = type
  }
  if(propertyType == "apartment") {
    propertyType = "Apartments"
  } else if(propertyType == "house") {
    propertyType = "Houses"
  } else if(propertyType == "maisonette") {
    propertyType = "Maisonettes"
  } else if(propertyType == "property") {
    propertyType = "Property"
  } else if(propertyType == "bungalow") {
    propertyType = "Bungalows"
  } else if(propertyType == "land") {
    propertyType = "Land"
  } else if(propertyType == "commercial") {
    propertyType = "Commercial"
  } else {
    propertyType = "Properties"
    if(pcategorytype === "new_developments") {
      propertyType = "New Homes";
    }
  }
  if(pcategorytype === "new_developments") {
    propertyType= "New Homes"
  }
   let mustIncludeTitle = ""
 
   if ( mustInclude ) {
     mustIncludeTitle = " with "+mustInclude.join(' and ').replace("parking", "Parking").replace("chain", "Chain").replace("outside", "Outside").replace(/-/g, ' ')
   }
   var DesctitleArea = toTitleCase(searchParams.areas.replace(/-/g, ' '))
   //DesctitleArea = DesctitleArea.replace("Essex", "Essex and Kent");

   var description = `Explore our latest collection of ${capitalize(propertyType)} ${actionStrDESC} ${DesctitleArea}. Contact Balgores estate agents in ${DesctitleArea} to find the right property for you.`
      if(searchParams.areas != 'essex-and-kent') {
        description= `Explore our range of property ${actionStrDESC} in ${DesctitleArea}. Contact our property experts to find the right property ${actionStrDESC} in ${DesctitleArea}.`
      }
      if (searchParams.type) {
        description=`Are you in search of  ${capitalize(propertyType)}${actionStrDESC} in ${DesctitleArea}? Balgores estate agents in ${DesctitleArea} are here to help.`;
      }

      if (searchParams.bedrooms) {     
        description=`Browse through the properties ${actionStrDESC} in ${DesctitleArea} with more than ${searchParams.bedrooms} bedrooms here. Contact our expert estate agents today to get assistance in finding the right property in ${DesctitleArea}.`;
      }
      if (searchParams.bedrooms && pcategorytype === "new_developments") { 
        description=`Browse through New homes ${actionStrDESC} with more than ${searchParams.bedrooms} bedrooms in ${DesctitleArea} here. Contact our expert estate agents today to get assistance in finding the right property in ${DesctitleArea}.`;
      }
      if (searchParams.price.min || searchParams.price.max) {
        description = `Locate the right property ${capitalize(searchParams.areas)} in ${capitalize(searchParams.areas)} ${priceStr} with Balgores estate agents. Book an appointment with one of our property experts in ${DesctitleArea}.`;
      }
      if (propertyType !="property" && (searchParams.price.min || searchParams.price.max)) {
        description = `Check out the latest collection of ${capitalize(propertyType)}${actionStrDESC} ${priceStr} in ${DesctitleArea} ${priceStr} with Balgores estate agents in ${priceStr}.`;
      }
      if (searchParams.bedrooms && (searchParams.price.min || searchParams.price.max)) { 
        description = `Explore the list of ${searchParams.bedrooms} bedroom properties ${actionStrDESC} in ${DesctitleArea} ${priceStr} with Balgores and Request a viewing for the property that interests you.`;
      }
      if (searchParams.bedrooms && searchParams.type) {  
        description = `Find the latest ${searchParams.bedrooms} bedroom ${capitalize(propertyType)} ${actionStrDESC} in ${DesctitleArea}. Contact Balgores estate agents in ${DesctitleArea}, to arrange a viewing.`;
      }
      
     //
     let titlePropertyType = ""
 
     if(type == "") {
         titlePropertyType = "Properties"
     } else if(type == "apartment") {
         titlePropertyType = "Apartments"
     } else if(type == "house") {
         titlePropertyType = "Houses"
     } else if(type == "maisonette") {
         titlePropertyType = "Maisonettes"
     } else if(type == "property") {
         titlePropertyType = "Property"
     } else if(type == "bungalow") {
         titlePropertyType = "Bungalows"
     } else if(type == "land") {
         titlePropertyType = "Land"
     } else if(type == "commercial") {
         titlePropertyType = "Commercial"
     } else {
         titlePropertyType = type
     }
     if(pcategorytype === "new_developments") {
      titlePropertyType= "New Homes"
      if(type !="") {
        titlePropertyType= "New Homes " +toTitleCase(type)
      }
    }
     let bedroomType = ""
 
     if ( bedrooms ) {
       bedroomType = ' with more than '+bedrooms+' bedrooms'
     }
     var titleArea = toTitleCase(areas.replace(/-/g, ' '))
         //titleArea = titleArea.replace("Essex", "Essex and Kent");
     let descTitle =  toTitleCase(titlePropertyType.replace(/-/g, ' ')) + actionStr + titleArea + bedroomType + priceStr + mustIncludeTitle
     //
 
   // console.log("Props Desc => ", desc);
   var { pathname } = useLocation()

   if (pathname == "/home/" || pathname == "/home" )
     pathname = "/"
   if (pathname == "/properties-for-sale" || pathname == "/properties-for-sale" )
     pathname = "/properties-for-sale/essex-and-kent"
   if (pathname == "/properties-to-rent/" || pathname == "properties-to-rent" )
     pathname = "/properties-to-rent/essex-and-kent"
 
   var curentUrl = '';
   curentUrl = process.env.GATSBY_SITE_URL+pathname;
 
   // set no index for result pagination
   let hasPagination = false;
   if (pathname !== undefined && pathname) {
     let pageStr = pathname.split('page-');
     hasPagination = pageStr[1] || false;
     if (pageStr[0] !== undefined) {
      curentUrl = process.env.GATSBY_SITE_URL + pageStr[0];
     }
   }
 
   if (!curentUrl.endsWith('/'))
         curentUrl = curentUrl + '/';
 
   //remove multiple slashes
   curentUrl = curentUrl.replace(/([^:]\/)\/+/g, "$1");
   //set lowercase url
   curentUrl = curentUrl.toLowerCase();
 
 
   let metaItems = [
     {
       name: `description`,
       content: description,
     },
     {
       property: `og:title`,
       content: descTitle,
     },
     {
       property: `og:description`,
       content: description,
     },
     {
       property: `og:type`,
       content: `website`,
     },
     {
      name: `og:url`,
      content: curentUrl,
    },
     {
       name: `twitter:card`,
       content: `summary`,
     },
     {
       name: `twitter:creator`,
       content: `Balgores`,
     },
     {
       name: `twitter:title`,
       content: descTitle,
     },
     {
       name: `twitter:description`,
       content: description,
     },
   ].concat(meta);
 
 
   
  //  if ( hasPagination ) {
  //    metaItems.push({
  //      name: `robots`,
  //      content: `noindex`,
  //    })
  //  }
 
   return (
     <Helmet
       htmlAttributes={{
         lang,
       }}
       link={[
        {
          href: curentUrl,
          rel: "canonical"
        }]}
       title={descTitle}
       titleTemplate={`%s | Balgores`}
       meta={metaItems}
     />
   )
 }
 
 SeoResults.defaultProps = {
   lang: `en`,
   meta: [],
   description: ``,
   title: ``,
   searchParams: [],
 }
 
 SeoResults.propTypes = {
   description: PropTypes.string,
   lang: PropTypes.string,
   meta: PropTypes.arrayOf(PropTypes.object),
   title: PropTypes.string.isRequired,
   searchParams: PropTypes.any,
 }
 
 export default SeoResults
 